/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPBANKVERIFICATIONTYPE = {
    Online: '1',
    Manual: '2'
} as const;
export type IAPBANKVERIFICATIONTYPE = typeof IAPBANKVERIFICATIONTYPE[keyof typeof IAPBANKVERIFICATIONTYPE];


export function IAPBANKVERIFICATIONTYPEFromJSON(json: any): IAPBANKVERIFICATIONTYPE {
    return IAPBANKVERIFICATIONTYPEFromJSONTyped(json, false);
}

export function IAPBANKVERIFICATIONTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPBANKVERIFICATIONTYPE {
    return json as IAPBANKVERIFICATIONTYPE;
}

export function IAPBANKVERIFICATIONTYPEToJSON(value?: IAPBANKVERIFICATIONTYPE | null): any {
    return value as any;
}

